<!-- LayerControl.vue -->
<template>
  <div>
    <button
      @click="isOpen = !isOpen"
      class="absolute top-3 left-3 bg-base-100 p-1.5 rounded-sm shadow-lg hover:bg-base-200"
      title="Toggle Layers"
    >
      <DefaultIcon name="layers" size="h-5 w-5" />
    </button>

    <div
      v-if="isOpen"
      class="absolute top-3 left-14 bg-base-100 p-3 rounded-sm shadow-lg min-w-50 z-50"
    >
      <div class="flex flex-col gap-2">
        <p class="text-sm font-medium">Sluoksniai</p>
        <label
          v-for="layer in layers"
          :key="layer.id"
          class="flex items-center gap-2 hover:bg-base-200 rounded-sm text-sm"
        >
          <input
            type="checkbox"
            v-model="layer.visible"
            class="toggle toggle-xs border-base-content/60"
            @change="toggleLayer(layer)"
          />
          {{ layer.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const props = defineProps({
  map: Object,
});

const isOpen = ref(false);

const layers = ref([
  { id: "bus-stops-layer", name: "Stotelės", visible: true },
  { id: "municipalities-layer", name: "Savivaldybės riba", visible: true },
  {
    id: "bus-stop-buffers-layer",
    name: "Stotelių buferiai (2 km)",
    visible: true,
  },
]);

function toggleLayer(layer) {
  if (props.map && props.map.loaded()) {
    props.map.setLayoutProperty(
      layer.id,
      "visibility",
      layer.visible ? "visible" : "none",
    );
  } else {
    console.warn("Map is not loaded yet.");
  }
}
</script>
